(function () {
	'use strict';

	const breakpoints = {
	  'sm': 600,
	  'md': 1024,
	  'lg': 1200,
	  'xl': 1440,
	  'page-max': 1660
	};

	var Breakpoints = /*#__PURE__*/Object.freeze({
		__proto__: null,
		breakpoints: breakpoints
	});

	const plus = `<svg class="plus" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.87 17.87">
    <path fill="currentColor" d="m8.94,0C4.01,0,0,4.01,0,8.94s4.01,8.94,8.94,8.94,8.94-4.01,8.94-8.94S13.86,0,8.94,0Zm0,16.87c-4.38,0-7.94-3.56-7.94-7.94S4.56,1,8.94,1s7.94,3.56,7.94,7.94-3.56,7.94-7.94,7.94Z" />
    <polygon fill="currentColor" points="9.44 4.34 8.44 4.34 8.44 8.44 4.34 8.44 4.34 9.44 8.44 9.44 8.44 13.53 9.44 13.53 9.44 9.44 13.53 9.44 13.53 8.44 9.44 8.44 9.44 4.34" />
  </svg>`;
	const envelope = `<svg width="100%" height="100%" class="envelope" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1964 0.75H14.25V8.25H0.75V0.75H0.803571L7.5 7L14.1964 0.75ZM13.0972 0.75H1.90277L7.5 5.97409L13.0972 0.75ZM0 0H15V9H0V0Z" fill="currentColor"/>
</svg>`;
	const arrowDown = `<svg class="arrow-icon" width="100%" height="100%" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_602_15144)">
    <path d="M2.72266 0.000174669L2.72266 6.50391" stroke="currentColor" stroke-width="0.5" stroke-miterlimit="10" />
    <path d="M5.26647 3.99644L3.99477 5.25017L2.72308 6.50391L1.45138 5.25017L0.179687 3.99644" stroke="currentColor" stroke-width="0.5" stroke-miterlimit="10" />
  </g>
  <defs>
    <clipPath id="clip0_602_15144">
      <rect width="7" height="5.44444" fill="white" transform="translate(0 7) rotate(-90)" />
    </clipPath>
  </defs>
</svg>`;
	const close = `<svg width="100%" height="100%" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="23.5" cy="23.5" r="23.25" stroke="black" stroke-opacity="0.3" stroke-width="0.5" />
  <path d="M26.9128 26.9128L21 21" stroke="#767676" stroke-width="0.5" stroke-miterlimit="10" />
  <path d="M26.9128 21.0872L21 27" stroke="#767676" stroke-width="0.5" stroke-miterlimit="10" />
</svg>`;
	const cart = `<svg width="100%" height="100%" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M6.96786 0.625C6.15631 0.625 5.35897 0.924845 4.7656 1.54933C4.17834 2.16737 3.81877 3.07333 3.81021 4.24365H2.48465C2.13568 4.24365 1.84488 4.50175 1.77841 4.85449L0.424082 12.9158C0.324377 13.518 0.773049 14.0687 1.35466 14.0687H12.4635C13.0534 14.0687 13.502 13.518 13.394 12.9158L12.0314 4.85449C11.9737 4.50455 11.6789 4.24776 11.3335 4.2437L11.3252 4.24365H10.1255C10.1169 3.07333 9.75737 2.16737 9.17012 1.54933C8.57674 0.924845 7.77941 0.625 6.96786 0.625ZM9.37548 4.24365C9.36702 3.22935 9.05803 2.52019 8.62642 2.06594C8.18773 1.60426 7.59367 1.375 6.96786 1.375C6.34204 1.375 5.74798 1.60426 5.3093 2.06594C4.87768 2.52019 4.56869 3.22935 4.56024 4.24365H9.37548ZM1.35466 13.3187C1.26359 13.3187 1.13096 13.2143 1.15955 13.0396L2.51129 4.99365H11.2985L12.6589 13.0415L12.6602 13.0489C12.6892 13.2107 12.5689 13.3187 12.4635 13.3187H1.35466Z"/>
<path class="filled" d="M13.0243 12.9783L13.0243 12.9783L13.0249 12.982C13.0939 13.3667 12.8074 13.6937 12.4635 13.6937H1.35466C1.02213 13.6937 0.729448 13.3686 0.793985 12.9774C0.794005 12.9773 0.794025 12.9772 0.794046 12.9771L2.14752 4.92083C2.18461 4.73126 2.33256 4.61865 2.48465 4.61865H11.3252C11.4847 4.61865 11.6321 4.73799 11.6614 4.9155L11.6616 4.91699L13.0243 12.9783Z" fill="black" stroke="black" stroke-width="0.75" stroke-miterlimit="10"/>
</svg>
`;

	var SvgTemplates = /*#__PURE__*/Object.freeze({
		__proto__: null,
		arrowDown: arrowDown,
		cart: cart,
		close: close,
		envelope: envelope,
		plus: plus
	});

	const clamp = (min, val, max) => Math.min(max, Math.max(min, val));
	const parseProductForm = formData => {
	  const regEx = /properties\[(.+?)\]/;
	  const array = [];
	  let obj = {};
	  for (const [key, value] of formData) {
	    const propertyKey = key.match(regEx)?.['1'];
	    if (key === 'id') {
	      obj = {
	        properties: {}
	      };
	      array.push(obj);
	    }
	    propertyKey ? obj['properties'][propertyKey] = value : obj[key] = value;
	  }
	  return array;
	};
	const dispatchEvent = (target, name, data) => {
	  const event = new CustomEvent(name, {
	    detail: data
	  });
	  target.dispatchEvent(event);
	};
	const generateImageUrl = url => {
	  let imageUrl = '';
	  if (url) {
	    imageUrl = url.replace('123x321', '768x');
	  }
	  return imageUrl;
	};
	const setScrollbarWidth = () => {
	  const outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.overflow = 'scroll';
	  outer.style.msOverflowStyle = 'scrollbar';
	  document.body.appendChild(outer);
	  const inner = document.createElement('div');
	  outer.appendChild(inner);
	  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
	  if (outer.parentNode) {
	    outer.parentNode.removeChild(outer);
	  }
	  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
	};
	const generateImageSrcset = url => {
	  let imageSrcset = '';
	  if (url) {
	    imageSrcset = `${url.replace('123x321', '2000x')} 2000w, ${url.replace('123x321', '1440x')} 1440w, ${url.replace('123x321', '1024x')} 1024w, ${url.replace('123x321', '768x')} 768w, ${url.replace('123x321', '468x')} 468w, ${url.replace('123x321', '200x')} 200w`;
	  }
	  return imageSrcset;
	};
	function getDocumentScrollTop() {
	  if (window.pageYOffset === undefined) {
	    return (document.documentElement || document.body.parentNode || document.body).scrollTop;
	  }
	  return window.pageYOffset;
	}
	function scrollToPosition(destination, duration, callback) {
	  const start = getDocumentScrollTop();
	  let startTime = 0;
	  const delta = destination - start;
	  function easing(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t + b;
	    }
	    t -= 2;
	    return c / 2 * (t * t * t + 2) + b;
	  }
	  function loop(time) {
	    startTime || (startTime = time);
	    const runTime = time - startTime;
	    if (duration > runTime) {
	      requestAnimationFrame(loop);
	      window.scrollTo(0, easing(runTime, start, delta, duration));
	    } else {
	      if (destination !== delta + start) {
	        window.scrollTo(0, delta + start);
	      }
	      if (typeof callback === 'function') {
	        callback(+new Date());
	      }
	    }
	  }
	  requestAnimationFrame(loop);
	}
	function scrollToElement(element, duration, offset = 0, callback) {
	  const rect = element.getBoundingClientRect();
	  const offsetTop = rect.top + getDocumentScrollTop() - offset;
	  scrollToPosition(offsetTop, duration || 500, callback);
	}
	function replaceInnerHtml(element, content) {
	  element.innerHTML = content;
	}
	function debounce(func) {
	  let timer;
	  return (timeout, ...args) => {
	    clearTimeout(timer);
	    timer = setTimeout(() => {
	      func.apply(this, args);
	    }, timeout);
	  };
	}
	const isMobile = () => window.innerWidth < breakpoints.md;
	const replaceMultiplePairs = (str, replacements) => {
	  const escapedChars = replacements.map(([char]) => char.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
	  const regex = new RegExp(escapedChars.join('|'), 'g');
	  return str.replace(regex, match => {
	    const replacement = replacements.find(([char]) => char === match);
	    return replacement ? replacement[1] : match;
	  });
	};

	var Utils = /*#__PURE__*/Object.freeze({
		__proto__: null,
		clamp: clamp,
		debounce: debounce,
		dispatchEvent: dispatchEvent,
		generateImageSrcset: generateImageSrcset,
		generateImageUrl: generateImageUrl,
		getDocumentScrollTop: getDocumentScrollTop,
		isMobile: isMobile,
		parseProductForm: parseProductForm,
		replaceInnerHtml: replaceInnerHtml,
		replaceMultiplePairs: replaceMultiplePairs,
		scrollToElement: scrollToElement,
		scrollToPosition: scrollToPosition,
		setScrollbarWidth: setScrollbarWidth
	});

	const compileCheckbox = (id, name, value, checked, label, dataRef) => {
	  return `<label class="form-control ts-label-s" for="${id}">
  <input type="checkbox" name="${name}" id="${id}" value="${value}" ${checked} data-ref="${dataRef}"/>
  ${label}
</label>`;
	};
	const loader = `<div class="loading">
      <span class="loading__dot"></span>
      <span class="loading__dot"></span>
      <span class="loading__dot"></span>
  </div>
`;
	const wrappedLoader = `<span class="btn-state is-loading" style="height: 10px;">
  <span class="state-label">
    ${loader}
  </span>
</span>
`;
	const favoriteButtonTemplate = id => `<div class="wishlist-btn fave-btn" data-product-id="${id}"></div>`;
	const imageTemplate = ({
	  src,
	  alt,
	  width,
	  height,
	  classes
	}) => `<img
    data-ref="image"
    src="${src}"
    alt="${alt || ''}"
    loading="lazy"
    width="${width}"
    height="${height}"
    class="${classes} image ${src.includes('.png') ? 'png' : ''}"
    srcset="${generateImageSrcset(src)}"
    sizes="100vw"
  >`;
	const addToCartBtnTemplate = (buttonStates, state) => `
  <button class="cta-primary--quick-add" data-ref="add-to-cart-btn" type="submit" data-state="${state}">
    <div class="cta-primary--quick-add__label ts-label-s">

      <div class="cta-primary--quick-add__text-container">
        <span class="btn-state is-default">
          <span class="state-label">
            <span class="state-label__icon">${cart}</span>
            <span class="state-label__text js-active-label">${buttonStates.default.label}</span>
            <div class="state-label__animation-text-container sm-only">
              <span class="state-label__animation-text">${buttonStates.animation.label}</span>
            </div>
          </span>
        </span>
        <span class="btn-state is-inactive">
          <span class="state-label">
          <span class="state-label__icon">${cart}</span>
          <span class="state-label__text">${buttonStates.inactive.label}</span>
          <div class="state-label__animation-text-container sm-only">
            <span class="state-label__animation-text">${buttonStates.animation.label}</span>
          </div>
          </span>
        </span>
        <span class="btn-state is-loading">
          <span class="state-label">
          ${loader}
          </span>
        </span>
        <span class="btn-state is-disabled">
          <span class="state-label">
          <span class="state-label__icon">${envelope}</span>
          <span class="state-label__text">${buttonStates.soldOut.label}</span>
          <div class="state-label__animation-text-container sm-only">
            <span class="state-label__animation-text">${buttonStates.animation.label}</span>
          </div>
          </span>
        </span>
        <span class="btn-state is-success">
          <span class="state-label">
            <span class="state-label__icon">${cart}</span>
            <span class="state-label__text">${buttonStates.success.label}</span>
            <div class="state-label__animation-text-container sm-only">
              <span class="state-label__animation-text">${buttonStates.animation.label}</span>
            </div>
          </span>
        </span>
      </div>
    </div>
  </button>`;
	const variantInputTemplate = (variant, productId) => {
	  const input_id = 'product-' + variant.id;
	  const statusClass = variant.available ? '' : 'is-disabled';
	  const icon = variant.available ? '' : envelope;
	  let isPreorder = '';
	  let preorderDate = '';
	  let formatted_date = '';
	  if ('pre_order' in variant) {
	    isPreorder = 'is-preorder';
	    preorderDate = variant.pre_order.date;
	    formatted_date = variant.pre_order.formatted_date;
	  }
	  return `<div id="pv-${variant.id}" class="variant-selector__variant ${statusClass + isPreorder}" data-pod="${preorderDate}" data-pofd="${formatted_date}" data-pid="${productId}">
      <input class="js-variant-input" id="${input_id}" type="radio" name="id" value="${variant.id}" data-availability="${variant.available}" />
      <label for="${input_id}"><span class="ts-label-s">${variant.option1} ${isPreorder ? '<p class="is-mobile">' + window.translations?.preorder + '</p>' : ''}</span>
        ${icon}
      </label>
      <input type="hidden" name="quantity" value="1">
    </div>`;
	};
	const variantSelectorTemplate = (variants, productId) => {
	  let colAmount = 2;
	  let dividedByThree = variants.length % 3;
	  if (dividedByThree == 0) {
	    colAmount = 3;
	  }
	  const options = variants.map(variant => variantInputTemplate(variant, productId)).join('');
	  return `<fieldset class="quick-buy-form__variant-selector variant-selector col-${colAmount} js-size-selector" data-ref="variant-selector">${options}</fieldset>`;
	};
	const productInputTemplate = variants => {
	  return `<input type="hidden" name="quantity" id="quantity" value="1">
  <input type="hidden" name="id" id="id" value="${variants[0].id}">`;
	};
	const preorderInputTemplate = (inputProperty, inputValue, preOrderDate) => {
	  return `<input id='pre-order' type='hidden' name='properties[${inputProperty}]' value='${inputValue}'>
  <input id='pre-order-tag' type='hidden' name='properties[_is_preorder]' value='true'>
  <input id='pre-order-date' type='hidden' name='properties[_preorder_date]' value='${preOrderDate}'>
  `;
	};
	const preorderProductLabel = label => {
	  return `<span class="ts-label-s preorder-label ts-grey js-preorder-label">${label}</span>`;
	};
	const soldOutProductLabel = label => {
	  return `<span class="ts-label-s soldout-label ts-grey">${label}</span>`;
	};

	var ElementTemplates = /*#__PURE__*/Object.freeze({
		__proto__: null,
		addToCartBtnTemplate: addToCartBtnTemplate,
		compileCheckbox: compileCheckbox,
		favoriteButtonTemplate: favoriteButtonTemplate,
		imageTemplate: imageTemplate,
		loader: loader,
		preorderInputTemplate: preorderInputTemplate,
		preorderProductLabel: preorderProductLabel,
		productInputTemplate: productInputTemplate,
		soldOutProductLabel: soldOutProductLabel,
		variantInputTemplate: variantInputTemplate,
		variantSelectorTemplate: variantSelectorTemplate,
		wrappedLoader: wrappedLoader
	});

	var events = {
	  PRODUCT_DATA_LOADED: 'PRODUCT_DATA_LOADED',
	  CART_UPDATED: 'CART_UPDATED',
	  CART_DOM_UPDATED: 'CART_DOM_UPDATED',
	  AJAX_UPDATED: 'AJAX_UPDATED',
	  CHANGE_CURSOR: 'CHANGE_CURSOR',
	  FAVORITES_UPDATED: 'FAVORITES_UPDATED',
	  WISHLIST_READY: 'WISHLIST_READY',
	  FILTERS_UPDATED: 'FILTERS_UPDATED',
	  PRODUCT_CARD_RENDERED: 'PRODUCT_CARD_RENDERED',
	  FILTER_CONTENT_UPDATED: 'FILTER_CONTENT_UPDATED',
	  CLOSE_OPTIONS: 'CLOSE_OPTIONS',
	  TOGGLE_BIS: 'TOGGLE_BIS',
	  UPDATE_BIS: 'UPDATE_BIS',
	  ANNOUNCEMENT_BAR_RENDERED: 'ANNOUNCEMENT_BAR_RENDERED',
	  TRIGGER_NOTIFICATION_LAYOUT: 'TRIGGER_NOTIFICATION_LAYOUT',
	  TOGGLE_DELETE_ADDRESS: 'TOGGLE_DELETE_ADDRESS'
	};

	var Events = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: events
	});

	const getBounding = element => {
	  const rect = element.getBoundingClientRect();
	  return {
	    top: rect.top + window.scrollY,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left,
	    width: rect.width,
	    height: rect.height,
	    x: rect.x,
	    y: rect.y + window.scrollY
	  };
	};
	const DURATION = 800;
	const DELAY = 5;
	const delay = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms));
	const getTransition = (duration = DURATION, delay = 0) => `all ${duration}ms ${delay}ms cubic-bezier(.35,0,.35,1)`;
	const reset = state => {
	  const props = ['transition', 'transition-delay', 'width', 'height', 'top', 'left', 'position', 'will-change'];
	  props.forEach(p => state.parent.el.style.removeProperty(p));
	  state.elements.forEach(s => {
	    props.forEach(p => s.el.style.removeProperty(p));
	  });
	};
	const resetDebounce = debounce(reset);
	const flip = async (name, cb) => {
	  const parent = document.querySelector(`[data-flip-parent="${name}"]`);
	  const elements = [...document.body.querySelectorAll(`[data-flip="${name}"]`)];
	  document.body.style.setProperty('--flip-duration', DURATION + elements.length * DELAY + 200 + 'ms');
	  const state = {
	    parent: {
	      el: parent,
	      height: parent.getBoundingClientRect().height
	    },
	    elements: elements.map(el => {
	      return {
	        el,
	        ...getBounding(el)
	      };
	    })
	  };
	  reset(state);
	  cb();
	  const {
	    height
	  } = parent.getBoundingClientRect();
	  state.parent = {
	    ...state.parent,
	    new: height
	  };
	  state.elements = state.elements.map(s => ({
	    ...s,
	    new: getBounding(s.el)
	  }));
	  state.parent.el.style.height = state.parent.height + 'px';
	  state.elements.forEach(s => {
	    s.el.style.position = 'absolute';
	    s.el.style.willChange = 'width, height, top, left';
	    s.el.style.width = s.width + 'px';
	    s.el.style.height = s.height + 'px';
	    s.el.style.top = s.top + 'px';
	    s.el.style.left = s.left + 'px';
	  });
	  await delay(0);
	  parent.style.transition = getTransition(DURATION);
	  parent.style.height = state.parent.new + 'px';
	  state.elements.forEach((s, idx) => {
	    s.el.style.transition = getTransition(DURATION + (elements.length - idx) * DELAY, (elements.length - idx) * DELAY);
	    s.el.style.width = s.new.width + 'px';
	    s.el.style.height = s.new.height + 'px';
	    s.el.style.top = s.new.top + 'px';
	    s.el.style.left = s.new.left + 'px';
	  });
	  resetDebounce(DURATION + elements.length * DELAY + 200, state);
	};

	var FlipAnimation = /*#__PURE__*/Object.freeze({
		__proto__: null,
		flip: flip
	});

	const hydrateComponents = (components, ...additionalFunctions) => {
	  return {
	    components,
	    teardownFunctions: [],
	    async hydrate() {
	      additionalFunctions?.forEach(func => func());
	      const initializedComponents = await Promise.all(components.filter(Boolean).map(async component => {
	        const c = await component;
	        if (c.default) return c.default();else return () => {};
	      }));
	      this.teardownFunctions = initializedComponents.filter(c => typeof c === 'function');
	      window.teardown = () => this.teardownFunctions.forEach(teardown => teardown());
	    }
	  };
	};

	var Hydration = /*#__PURE__*/Object.freeze({
		__proto__: null,
		hydrateComponents: hydrateComponents
	});

	const mutation = (el, cb, config = {
	  childList: true,
	  subtree: true
	}) => {
	  const callback = mutationList => {
	    for (const mutation of mutationList) {
	      if (mutation.type === 'childList') {
	        cb(mutation);
	      }
	    }
	  };
	  const observer = new MutationObserver(callback);
	  observer.observe(el, config);
	  return observer;
	};
	const intersection = (el, callback, config = {
	  threshold: [0]
	}) => {
	  const observer = new IntersectionObserver(callback, config);
	  if (el) {
	    observer.observe(el);
	  }
	  return observer;
	};

	var Observer = /*#__PURE__*/Object.freeze({
		__proto__: null,
		intersection: intersection,
		mutation: mutation
	});

	const classes = {
	  active: 'is-active',
	  hidden: 'is-hidden',
	  colorOption: 'js-color-option'
	};
	const {
	  title_edition,
	  add_to_cart,
	  added_to_cart,
	  notify_me,
	  preorder,
	  preorder_cta,
	  sold_out,
	  animation
	} = window.translations || {};
	const compileQuickShop = (product, collection) => {
	  let variantSelector = '';
	  let productInput = '';
	  let preorderInput = '';
	  let addToCartBtn = '';
	  let btnState;
	  const preOrderSettings = getPreOrderInfo(product);
	  const isPreOrder = preOrderSettings;
	  const firstProductVariant = product.variants[0];
	  const productTags = product.tags;
	  const id = 'add-to-cart-' + product.handle + '-' + collection + '-' + 'col-grid';
	  const buttonStates = {
	    default: {
	      label: isPreOrder ? preorder_cta : add_to_cart
	    },
	    inactive: {
	      label: add_to_cart
	    },
	    soldOut: {
	      label: `${sold_out} - ${notify_me}`
	    },
	    success: {
	      label: added_to_cart
	    },
	    preorder: {
	      label: preorder_cta
	    },
	    animation: {
	      label: animation
	    }
	  };
	  if (product.variants.length > 1) {
	    variantSelector = variantSelectorTemplate(product.variants, product.id);
	  } else {
	    productInput = productInputTemplate(product.variants);
	  }
	  let inputProperty = '';
	  let inputValue = '';
	  if (isPreOrder && preorder) {
	    if (firstProductVariant && 'pre_order' in firstProductVariant) {
	      inputProperty = preorder;
	      inputValue = firstProductVariant.pre_order.formatted_date;
	    }
	  }
	  preorderInput = preorderInputTemplate(inputProperty, inputValue, firstProductVariant?.pre_order?.date);
	  btnState = product.available ? 'default' : 'disabled';
	  addToCartBtn = addToCartBtnTemplate(buttonStates, btnState);
	  const template = `
    <div class="quick-buy-form js-product-form" data-tags="${productTags}" data-handle="${product.handle}">
      <form id=${id} data-ref="product-form">
      ${variantSelector}
      ${productInput}
      ${preorderInput}
      ${addToCartBtn}
    </form>
  </div>
`;
	  return template;
	};
	const getPreOrderInfo = product => {
	  let preOrderInProduct = 0;
	  if (product.variants.length === 1 && 'pre_order' in product.variants[0]) {
	    return true;
	  }
	  product.variants.forEach(variant => {
	    if (product.variants.length > 1 && variant.available && 'pre_order' in variant || !variant.available) {
	      preOrderInProduct += 1;
	    }
	  });
	  return preOrderInProduct === product.variants.length ? true : false;
	};
	const compileProductCard = (product, idx, collection) => {
	  let isMobile = window.innerWidth < breakpoints.md;
	  let layoutClass = '';
	  let delay = 0.02;
	  let animationDelay = idx * delay;
	  let quickShopOptions = '';
	  let hoverImg = '';
	  let compareAtPrice = '';
	  let upcyclingTagName = 'plèi';
	  let upcyclingTag = '';
	  let hoverImgUrl;
	  let soldOutLabel = '';
	  let preorderTitle = '';
	  let preorderInfo = '';
	  const firstProductVariant = product.variants[0];
	  const preOrderSettings = getPreOrderInfo(product);
	  const isPreOrder = preOrderSettings;
	  const titleArray = product.title.split('-');
	  const edition = titleArray[titleArray.length - 1];
	  const editionLabel = title_edition?.replace('{{ edition }}', edition);
	  const url = product.url;
	  const title = titleArray[0];
	  const price = product.variants[0].price;
	  const productImg = product.featured_image_url ? product.featured_image_url : product.images ? product.images[0]?.src : '';
	  quickShopOptions = compileQuickShop(product, collection);
	  if (product.tags.includes(upcyclingTagName)) {
	    upcyclingTag = '<div class="product-card__tag"></div>';
	  }
	  if (product.variants[0].compare_at_price) {
	    compareAtPrice = `<span class="ts-discount">${product.variants[0].compare_at_price}</span>`;
	  }
	  if (product.hover_image && !isMobile) {
	    hoverImgUrl = generateImageUrl(product.hover_image);
	    hoverImg = `<div class="product-card__image is-hover" style="background-image: url(${generateImageUrl(hoverImgUrl)});"></div>`;
	  }
	  if (!product.available) {
	    soldOutLabel = soldOutProductLabel(sold_out);
	  }
	  if (isPreOrder && preorder) {
	    if (firstProductVariant && 'pre_order' in firstProductVariant) {
	      preorderTitle = preorder;
	      preorderInfo = firstProductVariant.pre_order.formatted_date;
	    }
	  }
	  const imgSrc = generateImageUrl(productImg);
	  const productCardTemplate = `
  <article class="product-card js-card is-animation-card ${layoutClass} item-${idx}" data-ref="product-card" style="transition-delay: ${animationDelay}s;" data-flip="grid">
    <a class="product-card__inner js-product-anchor" href="${url}">
      <div class="product-card__image-container">
        <div class="product-card__image is-default" data-ref="product-card-img" data-img-src="${imgSrc}" style="background-image: url(${imgSrc});"></div>
        ${hoverImg}
        ${upcyclingTag}
        <div id="preorder-${product.id}" class="product-card__preorder-info">
		${isPreOrder && 'pre_order' in firstProductVariant ? `
			<span class="ts-label-s js-preorder-title">${preorderTitle}</span>
			<span class="ts-label-s ts-grey js-preorder-info">${preorderInfo}</span>
		` : ''}
		</div>
      </div>
      <div class="product-card__details">
        <div class="product-card__form">
          ${quickShopOptions}
          <span class="product-card__error ts-error ts-label-s" data-ref="error-container"></span>
        </div>
        <div class="product-card__details-text">
          <div class="product-card__fave-btn">
            ${favoriteButtonTemplate(product.id)}
          </div>
          <h3 class="ts-label-s">${title}</h3>
          <p class="ts-label-s edition-label ts-grey">${editionLabel}</p>
          <span class="ts-label-s preorder-label ts-grey js-preorder-label"></span>
          ${soldOutLabel}
          <span class="ts-label-s price-label">${compareAtPrice} ${price}</span>
        </div>
      </div>
    </a>
  </article>
`;
	  return productCardTemplate;
	};
	const compileColorOptionCard = (product, isCurrent) => {
	  const productCardTemplate = `
    <article class="product-card is-mini js-color-option ${classes.colorOption} ${isCurrent}">
      <a class="product-card__inner" href="${product.url}">
        <div class="product-card__image-container">
          <div class="product-card__image" style="background-image: url(${generateImageUrl(product.featured_image_url)});"></div>
        </div>
      </a>
    </article>
  `;
	  return productCardTemplate;
	};

	var ProductTemplates = /*#__PURE__*/Object.freeze({
		__proto__: null,
		compileColorOptionCard: compileColorOptionCard,
		compileProductCard: compileProductCard
	});

	const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
	const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
	function groupByRef(element, result, onlyFirst = false) {
	  const ref = element.getAttribute('data-ref');
	  if (!ref) return;
	  const refs = ref.split(' ').map(camelCase);
	  refs.forEach(capitalizedRef => {
	    if (onlyFirst) {
	      if (!result[capitalizedRef]) {
	        result[capitalizedRef] = element;
	      }
	    } else {
	      if (result[capitalizedRef]) {
	        if (Array.isArray(result[capitalizedRef])) {
	          result[capitalizedRef].push(element);
	        } else {
	          result[capitalizedRef] = [result[capitalizedRef], element];
	        }
	      } else {
	        result[capitalizedRef] = element;
	      }
	    }
	  });
	}
	const getElementByRef = (refs, target) => {
	  const root = target instanceof HTMLElement ? target : document.body;
	  const result = {};
	  const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref="${ref}"]`).join(',') : `[data-ref="${refs}"]`;
	  const elements = root.querySelectorAll(selector);
	  if (!elements) return {};
	  elements.forEach(element => groupByRef(element, result, true));
	  return result;
	};
	const getElementsByRef = (refs, target) => {
	  const root = target instanceof HTMLElement ? target : document.body;
	  const result = {};
	  const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
	  const elements = root.querySelectorAll(selector);
	  elements.forEach(element => groupByRef(element, result));
	  return result;
	};
	const getRefs = (target = document.body, watch) => {
	  const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
	  if (!root) {
	    return;
	  }
	  const name = root?.getAttribute('data-namespace');
	  return watch ? _watched(root, name, watch) : _refs(root, name, true);
	};
	function _refs(root, name, includeRoot) {
	  const attribute = name ? `data-ref-${name}` : 'data-ref';
	  return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
	    const dataset = name ? `ref${capitalize(name)}` : 'ref';
	    return {
	      ...(includeRoot && {
	        root
	      }),
	      ...refs,
	      ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
	        ...acc,
	        [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
	      }), {})
	    };
	  }, {});
	}
	function _watched(r, n, onChange) {
	  const observer = new MutationObserver(() => {
	    ref.current = _refs(r, n);
	    typeof onChange === 'function' && onChange();
	  });
	  observer.observe(r, {
	    childList: true,
	    subtree: true
	  });
	  const ref = {
	    root: r,
	    current: _refs(r, n),
	    unwatch: observer.disconnect.bind(observer)
	  };
	  return ref;
	}
	const ref = getRefs();

	var Refs = /*#__PURE__*/Object.freeze({
		__proto__: null,
		camelCase: camelCase,
		capitalize: capitalize,
		getElementByRef: getElementByRef,
		getElementsByRef: getElementsByRef,
		getRefs: getRefs,
		ref: ref
	});

	var scrollLock = lock => {
	  document.body.style.overflowY = lock ? 'hidden' : 'auto';
	};

	var ScrollLock = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: scrollLock
	});

	var Language;
	(function (Language) {
	  Language["en"] = "en";
	  Language["fr"] = "fr";
	  Language["de"] = "de";
	  Language["nl"] = "nl";
	  Language["ko"] = "ko";
	  Language["ja"] = "ja";
	})(Language || (Language = {}));
	const dateRegex = /[^0-9년월일年月日\-./ ]/g;
	const languageFormats = {
	  en: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  },
	  fr: {
	    year: 'A',
	    month: 'M',
	    day: 'J'
	  },
	  de: {
	    year: 'J',
	    month: 'M',
	    day: 'T'
	  },
	  nl: {
	    year: 'J',
	    month: 'M',
	    day: 'D'
	  },
	  ko: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  },
	  ja: {
	    year: 'Y',
	    month: 'M',
	    day: 'D'
	  }
	};
	const displayFormats = {
	  en: 'MM/DD/YYYY',
	  fr: 'DD/MM/YYYY',
	  de: 'DD.MM.YYYY',
	  nl: 'DD-MM-YYYY',
	  ko: 'YYYY년 MM월 DD일',
	  ja: 'YYYY年MM月DD日'
	};
	const browserLocale = window.Shopify?.locale.split('-')[0].trim() ?? navigator.language.split('-')[0].trim() ?? 'en';
	const storeLanguage = window.Shopify?.locale && window.Shopify?.country ? window.Shopify?.locale && window.Shopify?.locale.includes('-') ? window.Shopify?.locale : window.Shopify?.locale + '-' + window.Shopify?.country : navigator.language;
	const browserFormat = (() => {
	  try {
	    const parts = new Intl.DateTimeFormat(storeLanguage || 'en-US').formatToParts(new Date(2000, 0, 15));
	    return parts.map(part => {
	      if (part.type === 'day') return 'DD';
	      if (part.type === 'month') return 'MM';
	      if (part.type === 'year') return 'YYYY';
	      return part.value;
	    }).join('');
	  } catch (error) {}
	})();
	const noSepFormats = {
	  en: ['MMDDYYYY', 'DDMMYYYY'],
	  fr: ['DDMMYYYY', 'MMDDYYYY'],
	  de: ['DDMMYYYY', 'MMDDYYYY'],
	  nl: ['DDMMYYYY', 'MMDDYYYY'],
	  ko: ['YYYYMMDD', 'YYYYDDMM'],
	  ja: ['YYYYMMDD', 'YYYYDDMM']
	};
	const parseFormats = ['YYYY-MM-DD', 'YYYY-DD-MM', 'DD-MM-YYYY', 'MM-DD-YYYY', 'YYYY/MM/DD', 'YYYY/DD/MM', 'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY.MM.DD', 'YYYY.DD.MM', 'DD.MM.YYYY', 'MM.DD.YYYY', 'YYYY년MM월DD일', 'YYYY년 MM월 DD일', 'YYYY年MM月DD日', 'YYYY年 MM月 DD日', 'YYYY MM DD', 'YYYY DD MM', 'DD MM YYYY', 'MM DD YYYY', ...(noSepFormats[browserLocale] ?? [])];

	var ConstantsDate = /*#__PURE__*/Object.freeze({
		__proto__: null,
		get Language () { return Language; },
		browserFormat: browserFormat,
		browserLocale: browserLocale,
		dateRegex: dateRegex,
		displayFormats: displayFormats,
		languageFormats: languageFormats,
		noSepFormats: noSepFormats,
		parseFormats: parseFormats,
		storeLanguage: storeLanguage
	});

	class DateFormat {
	  defaultFormat = displayFormats[browserLocale] ?? browserFormat;
	  placeholder = this.defaultFormat;
	  constructor(locale) {
	    this.language = locale ?? storeLanguage;
	    if (browserLocale in languageFormats) this.placeholder = replaceMultiplePairs(this.defaultFormat, [['Y', languageFormats[browserLocale].year], ['M', languageFormats[browserLocale].month], ['D', languageFormats[browserLocale].day]]);
	  }
	  cleanForDigitOnly(str) {
	    return str.replace(/[^0-9]/g, '');
	  }
	  cleanAndNormalize(str) {
	    return str.replace(dateRegex, '').replace(/\s+/g, ' ').trim();
	  }
	  parse(str) {
	    const normalized = this.cleanAndNormalize(str);
	    const digitOnly = this.cleanForDigitOnly(normalized);
	    let result = undefined;
	    if (digitOnly.length != 8) return undefined;
	    parseFormats.find(format => {
	      if (normalized.length != format.length) return false;
	      const date = {
	        D: '',
	        M: '',
	        Y: ''
	      };
	      for (let i = 0; i < format.length; i++) {
	        if (['D', 'M', 'Y'].includes(format[i]) && normalized[i] >= '0' && normalized[i] <= '9') {
	          date[format[i]] += normalized[i];
	          continue;
	        }
	        if (format[i] != normalized[i]) return false;
	      }
	      const timestamp = Date.parse(`${date.Y}-${date.M}-${date.D}`);
	      if (isNaN(timestamp)) return false;
	      result = timestamp;
	      return true;
	    });
	    return result;
	  }
	  convertValueToTimestamp(value) {
	    if (typeof value == 'number') return value;else if (typeof value == 'string') return this.parse(value);else return undefined;
	  }
	  format(value, format) {
	    let timestamp = this.convertValueToTimestamp(value);
	    if (!timestamp) return undefined;
	    const dateObj = new Date(timestamp);
	    if (format) {
	      const date = {
	        D: String(dateObj.getDate()).padStart(2, '0').split(''),
	        M: String(dateObj.getMonth() + 1).padStart(2, '0').split(''),
	        Y: String(dateObj.getFullYear()).split('')
	      };
	      let formatted = format.split('').map(char => {
	        if (['D', 'M', 'Y'].includes(char)) return date[char].shift();
	        return char;
	      }).join('');
	      return formatted;
	    } else {
	      return dateObj.toLocaleDateString(this.language);
	    }
	  }
	}

	window.PoleneLibs = {
	  Utils,
	  Refs,
	  Breakpoints,
	  Events,
	  Observer,
	  SvgTemplates,
	  ScrollLock,
	  FlipAnimation,
	  ElementTemplates,
	  ProductTemplates,
	  Hydration,
	  ConstantsDate,
	  DateFormat
	};

})();
